import React from "react";
import clsx from "clsx";

const SearchCorrectionSubtitle = ({ correction, query, handleSearchCorrection }) => {
	if (!correction?.sub_title) {
		return null;
	}

	const [prefixText, suffixText] = correction.sub_title.split("%s");

	return (
		<span
			data-testid="correction-subtitle"
			className={clsx(
				"text-[12px] font-[400] leading-[16px] text-[#827485] md:text-[16px] md:font-[400] md:leading-[24px] md:text-[#190A28]",
				{
					"text-[12px] font-[600] leading-[16px] !text-[#190A28] md:text-[20px] md:font-[700] md:leading-[28px]":
						!correction?.is_implicit,
				}
			)}
		>
			{prefixText}
			<button
				type="button"
				className={clsx("cursor-pointer italic text-[#0074E8] underline", {
					"font-[600px]": !correction?.is_implicit,
				})}
				onClick={handleSearchCorrection}
			>
				{correction?.is_implicit ? query?.text : correction?.text}
			</button>
			&nbsp;{suffixText}
		</span>
	);
};

export default SearchCorrectionSubtitle;
